import { GhostInstanceData } from '../../stores/use-timeline-store';

/**
 * Calculates the visual position of a ghost element on the timeline
 */
export const calculateGhostPosition = (
  startTime: number,
  duration: number,
  trackIndex: number,
  totalDuration: number,
  totalTracks: number
): GhostInstanceData => {
  const leftPercentage = (startTime / totalDuration) * 100;
  const widthPercentage = (duration / totalDuration) * 100;
  const topPercentage = trackIndex * (100 / totalTracks);

  return {
    id: 'ghost',
    left: Math.max(0, leftPercentage),
    width: Math.max(0.1, widthPercentage),
    top: topPercentage,
  };
};
